import { render, staticRenderFns } from "./UpgradeAiQuestionModal.vue?vue&type=template&id=ae60738c&"
import script from "./UpgradeAiQuestionModal.vue?vue&type=script&lang=js&"
export * from "./UpgradeAiQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeAiQuestionModal.vue?vue&type=style&index=0&id=ae60738c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports